import React from "react";
import LogoLight from "../assets/images/LogoLight";

const DarkModeLogo = () => {
    return (
        <div className="">
            <LogoLight />
        </div>
    );
};

export default DarkModeLogo;
